"use strict";
/*
  This file is part of web3x.

  web3x is free software: you can redistribute it and/or modify
  it under the terms of the GNU Lesser General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  web3x is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Lesser General Public License for more details.

  You should have received a copy of the GNU Lesser General Public License
  along with web3x.  If not, see <http://www.gnu.org/licenses/>.
*/

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var abi_coder_1 = require("../abi-coder");

var ContractEntry = /*#__PURE__*/function () {
  function ContractEntry(entry) {
    _classCallCheck(this, ContractEntry);

    this.entry = entry;
  }

  _createClass(ContractEntry, [{
    key: "asString",
    value: function asString() {
      return abi_coder_1.abiCoder.abiMethodToString(this.entry);
    }
  }, {
    key: "name",
    get: function get() {
      return this.entry.name;
    }
  }, {
    key: "anonymous",
    get: function get() {
      return this.entry.anonymous || false;
    }
  }]);

  return ContractEntry;
}();

exports.ContractEntry = ContractEntry;